import React from 'react';
import { FieldValues, SubmitHandler, useFormContext } from 'react-hook-form';
import useTranslation from '../../../../Hooks/useTranslation';
import useNotification from '../../../../Hooks/useNotification';
import Text from '../Text';
import { useValidation } from '../../../../Utils/Validation';

export interface SubmitButtonProps<T extends FieldValues = FieldValues> {
	onSubmit: SubmitHandler<T>;
	disabled?: boolean;
	title?: string;
	className?: string;
}

const SubmitButton = <T extends FieldValues = FieldValues>(
	props: SubmitButtonProps<T>,
) => {
	const { onSubmit, title = 'base.create', className, disabled } = props;
	const { t } = useTranslation();

	const { showNotificationAlert } = useNotification();
	const methods = useFormContext<T>();

	const resolveErrorMessage = (error: any) => {
		if (!error) return;

		if (typeof error?.message !== 'undefined') {
			const errorMessage = t(error?.message?.toString());
			if (errorMessage) {
				showNotificationAlert({
					content: t(errorMessage),
				});
			}
		} else {
			if (Array.isArray(error)) {
				for (let i = 0; i < error.length; i++) {
					resolveErrorMessage(error[i]);
				}
			} else {
				for (const key of Object.keys(error)) {
					resolveErrorMessage(error[key]);
				}
			}
		}
	};

	const handlePress = () => {
		if (disabled) return;

		const onValid: SubmitHandler<T> = values => {
			onSubmit(values);
		};

		const onInvalid = (errors: any) => {
			console.log('❌ Chyby validace:', errors);
			console.log('📋 Hodnoty při chybné validaci:', methods.getValues());
			for (const key in errors) resolveErrorMessage((errors as any)[key]);
		};

		methods.handleSubmit(onValid, onInvalid)();
	};

	return (
		<button
			className={className || 'btn btn-green-global remastered'}
			type='button'
			onClick={handlePress}
			disabled={disabled}
		>
			{title && <Text tx={title} inline={true} firstUpper={true} />}
		</button>
	);
};

export default SubmitButton;
